import {debounce} from 'lodash';

export default {
    state: {
        cartId: null,
        products: [],
        multiyear: 1,
        recoverToken: null,
    },
    mutations: {
        setRecoverToken(state, token) {
            state.recoverToken = token;
        },
        clearCart(state) {
            state.cartId = null;
            state.products = [];
            state.multiyear = null;
            state.recoverToken = null;
        },
        setCartId(state, id) {
            state.cartId = id;
        },
        removeItem (state, payload) {
            let products = state.products

            var index = _.findIndex(products, {
                legacy_id: payload.legacy_id,
                state: payload.state
            })

            products.splice(index, 1)
        },
        addItem (state, payload) {
            let product = {}

            // Find existing cart item
            if (payload.format) {
                product = _.find(state.products, {
                    legacy_id: payload.legacy_id,
                    type: payload.type,
                    state: payload.state
                })
            } else {
                product = _.find(state.products, {
                    id: payload.id,
                    sku: payload.sku
                })
            }

            let hasExistingItemInCart = (product) ? true : false;
            let isProductSameFormat = product && product.format == payload.format;

            // Update quantity of existing item
            if (hasExistingItemInCart && isProductSameFormat) {
                product.quantity = +product.quantity + +payload.quantity;
                product.teachers = +product.teachers + +payload.teachers;
                return;
            }

            // Add new item to cart
            if (!hasExistingItemInCart) {
                // if product is not already added to the cart, push to cart products array
                state.products.push(payload);
                return;
            }
        },
        updateQuantity (state, payload) {
            let products = state.products

            let product = {}

            if (payload.format) {
                product = _.find(products, {
                    legacy_id: payload.legacy_id,
                    type: payload.type,
                    format: payload.format,
                    state: payload.state
                })
            } else {
                product = _.find(products, {
                    id: payload.id,
                    sku: payload.sku
                })
            }

            if (product) {
                // if product is found in the cart, sum the product quantity and  payload
                var total = +product.quantity + +payload.quantity
                product.quantity = total
            }

            // if the quantity is decreased to 0, remove product
            if (!payload.quantity || payload.quantity == 0) {
                products.splice(product, 1)
            }
        },
        updateTeachers (state, payload) {
            let products = state.products

            let product = {}

            if (payload.format) {
                product = _.find(products, {
                    legacy_id: payload.legacy_id,
                    type: payload.type,
                    format: payload.format,
                    state: payload.state
                })
            } else {
                product = _.find(products, {
                    id: payload.id,
                    sku: payload.sku
                })
            }

            if (product) {
                // if product is found in the cart, sum the product quantity and  payload
                var total = +product.teachers + +payload.teachers
                product.teachers = total
            }
        },

        setProducts (state, payload) {
            state.products = payload
        },
        setMultiyearValue (state, {label, value}) {
            console.log(`Setting multiyear value: ${label} = ${value}`);
            state.multiyear = value
        },
        setProductBundleDismissed (state, {product_identifier, grade, language, value}) {
            if(!state.bundle_dismissed_items) {
                state.bundle_dismissed_items = {}
            }
            
            state.bundle_dismissed_items = {
                ...state.bundle_dismissed_items,
                [product_identifier]: value
            }

            // if(value == 1) {
            //     console.log('Dismissed...' + product_id + ',value=' + value)
            // }
            // else if(value == 2) {
            //     console.log('Added...' + product_id + ',value=' + value)
            // }
        },
        setProductBundleCartDismissed (state, {product_identifier, grade, language, value}) {
            if(!state.bundle_cart_dismissed_items) {
                state.bundle_cart_dismissed_items = {}
            }
            
            state.bundle_cart_dismissed_items = {
                ...state.bundle_cart_dismissed_items,
                [product_identifier]: value
            }
        },
        resetProductBundleDismissed (state) {
            state.bundle_dismissed_items = {}
            state.bundle_cart_dismissed_items = {}
        },
    },
    getters: {
        getCartToken(state) {
            return state.recoverToken;
        },
        getCartProducts(state) {
            return state.products;
        },
        multiyear(state) {
            if (state.multiyear)
                return state.multiyear;

            return 1;
        }
    },
    actions: {
        debounceUpdate: debounce(({state,commit,dispatch}) =>
        {
            dispatch('updateCart');
        }, 1500),

        removeItem ({commit, dispatch}, data)
        {
            commit('removeItem', data);
            dispatch('debounceUpdate');
        },
        addItem ({commit, dispatch}, payload)
        {
            console.log('Adding item to cart: ', payload);
            commit('addItem', payload);
            dispatch('debounceUpdate');
        },
        updateQuantity ({commit, dispatch}, payload)
        {
            commit('updateQuantity', payload);
            dispatch('debounceUpdate');
        },
        updateTeachers ({commit, dispatch}, payload) {
            commit('updateTeachers', payload);
            dispatch('debounceUpdate');
        },

        bundleOffered(state, bundleType) {
            let data = {
                state: this.getters.getSelectedState,
                user_id: this._vm.$auth.user().id,
                bundle_type: bundleType,
            }
            return this._vm.axios.post("/bundle/offered", data);
        },
        async bundleInteraction(state, bundleType, interaction) {
            return this._vm.axios.post("/bundle/interaction", {
                state: this.getters.getSelectedState,
                user_id: this._vm.$auth.user().id,
                bundle_type: bundleType,
                interaction: interaction,
            })
        },
        async getCart(context) {
            let response = await this._vm.axios.get("/cart/");
            return response.data;
        },
        async getCartForToken(context, token) {
            let response = await this._vm.axios.get("/cart/get/" + token);
            return response.data;
        },
        async updateCart(context) {
            let userId = (this._vm.$auth.user() || {}).id;
            let subtotal = context.state.products.reduce((currentPrice, product) => {
                let price;
                if (product.prices) {
                    let priceForFormats = product.prices[product.multiyear];
                    let homeschool = (product.quantity < 10) ? '_2' : '';
                    let keyForPrice = `${product.format}${homeschool}_singleprice`;
                    price = priceForFormats[keyForPrice] || 0;
                    price *= product.multiyear;
                } else {
                    price = product.price || 0;
                }

                price *= product.quantity;

                return currentPrice + price;
            }, 0);

            subtotal = Math.round((subtotal + Number.EPSILON) * 100) / 100;

            let products = context.state.products.map((p) =>
                ({
                    legacy_id: p.legacy_id,
                    sku: p.sku,
                    quantity: p.quantity,
                    teachers: p.teachers,
                    multiyear: p.multiyear,
                    format: p.format,
                    title: p.title,
                    subject: p.subject,
                    state: p.state,
                }));


            let data = {
                id: context.state.cartId,
                state: this.getters.getSelectedState,
                user_id: userId,
                products: products,
                subtotal: subtotal,
                homeschool: context.rootState.homeschool.homeschoolStore,
            };
            let response = await this._vm.axios.post("/cart/update", data);
            context.commit('setCartId', response.data.cart_id);
            return response.data.cart_id;
        },
    }
}
